import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },

  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'black',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    bg: '#2E5470',
    color: 'white',
    overflow: 'none',

    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    // bgGradient: 'linear(to-b, beta.600, beta.700)',
    bg: '#1E3649',
    border: '8px solid #2E5470',
    boxShadow: '0 0 6px rgba(0, 0, 0, 0.6)',
    padding: '10px',
  },

  tab: {
    bg: 'beta.500',
    borderColor: '#70B6EA',
    color: '#203A4E',
    fontSize: '2xs',
    fontWeight: 'bold',
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'beta.700',
      borderBottomColor: 'transparent',
      color: '#70B6EA',
    },
  },
};
